import styled from 'styled-components'

type PaginationItemProps = {
    selected?: boolean
}

export const Item = styled.li<PaginationItemProps>`
    display: inline-block;
    list-style: none;
    padding-left: 10px;
`

export const EllipsisItem = styled(Item)<Omit<PaginationItemProps, 'selected'>>`
    pointer-events: none;

    ::after {
        content: '…';
    }
`
